import { useAPIQuery } from 'shared/api/APIQuery';
import { requestJSONLoadboardAPI } from 'shared/api/LoadboardAPIClient';
import { useFlaggedSchema } from 'shared/hooks/useFlaggedSchema';
import { yupObject, yupString } from 'shared/utils/YupUtils';
import { array } from 'yup';
import { z } from 'zod';

export type ShipperDTO = z.infer<typeof shipperSchema>;

const shipperYupSchema = yupObject({
  guid: yupString(),
  name: yupString(),
  city: yupString(),
  state: yupString(),
});

const shipperSchema = z.object({
  guid: z
    .string()
    .nullish()
    .transform((value) => value ?? ''),
  name: z
    .string()
    .nullish()
    .transform((value) => value ?? ''),
  city: z
    .string()
    .nullish()
    .transform((value) => value ?? ''),
  state: z
    .string()
    .nullish()
    .transform((value) => value ?? ''),
});

export function useShippers(name: string) {
  const schema = useFlaggedSchema(
    'ctms_loadboard_zod_schema',
    array(shipperYupSchema).required(),
    z.array(shipperSchema),
  );

  return useAPIQuery<ShipperDTO[]>(
    ['shippers', name],
    () =>
      requestJSONLoadboardAPI([
        'GET /internal/v3/shippers/search{?name}',
        { name },
      ]),
    { enabled: name.length > 2, schema },
  );
}
